import React from 'react'
import { Route, Routes, Link, BrowserRouter } from "react-router-dom";
import mobileCelebrityImage from "../../../assets/contact-mobile.png";
import backBtnMobile from "../../../assets/backBtnMobile.png";
import mobileContactContent from "../../../assets/mb-contact-content.png"
import './contactUs.css'

const ContactUs = () => {
  return (
    <div className="mb-about-container">
    <div className="mb-about-topContainer">
    <Link to={'/'}> <img src={backBtnMobile} className="backBtnMobile" /></Link>
      <div className="mb-aboutHeading">
CONTACT US
      </div>
    </div>

    <div className="mb-about-contentContainer">
      <img src={mobileCelebrityImage} className="mb-celebrityImage" />

      <div className="mb-about-content-container">

            <img src={mobileContactContent} className='aboutAnantContentImage'/>
      </div>
    </div>
  </div>  
  )
}

export default ContactUs